import React from 'react';
import JamakeContainer from '../../components/jamake/JamakeContainer';

/**
 * JamakePage - 컨테이너 패턴을 사용한 페이지 컴포넌트
 * 
 * 이제 단순히 컨테이너 컴포넌트를 렌더링하는 역할만 함
 * 모든 로직은 JamakeContainer와 useJamakeData 훅으로 이동
 */
const JamakePage: React.FC = () => {
  return <JamakeContainer />;
};

export default JamakePage;